import { render, staticRenderFns } from "./Samfap.vue?vue&type=template&id=17a16fa0&scoped=true&"
import script from "./Samfap.vue?vue&type=script&lang=js&"
export * from "./Samfap.vue?vue&type=script&lang=js&"
import style0 from "./Samfap.vue?vue&type=style&index=0&id=17a16fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a16fa0",
  null
  
)

export default component.exports